import React from "react";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import CorteOSGrid from "./CorteOSGrid";
import Typography from "@material-ui/core/Typography";
import CorteOS from "./CorteOS";

const useStyles = makeStyles(theme => ({
    dashboardSection: {
        // padding: "5px"
    },
    mainGrid: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    mainOpenCorte: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    mainOSLista: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    }

}));

const CorteOperacaoView = (props) => {
    const classes = useStyles();
    const { ordemServicos } = props;

    // console.log("CorteOperacaoView Return");
    return (
        <React.Fragment>

                <Grid container className={classes.mainGrid}>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        ORDENS DE SERVIÇO PARA CORTE: ({ordemServicos.filter( (o,ix) => o.resultado === 0 ).length})
                    </Typography>
                    <Grid  item className={classes.mainOpenCorte}  xs={12} sm={12} md={12} lg={12} xl={12}>
                        { props.openCorte && <CorteOS ordemServico={props.osCortando} cbOpenCorte={props.cbOpenCorte}/> }
                    </Grid>

                    <Grid container item className={classes.mainOSLista}  xs={12} sm={12} md={12} lg={12} xl={12}>
                        { ordemServicos
                            .filter( (o,ix) => o.resultado === 0 )
                            .map( (e, ix) => {
                                return (<CorteOSGrid key={ix} ordemServico={e} index={ix} cbOpenCorte={props.cbOpenCorte} /> );
                            }) }
                        {
                            (ordemServicos.filter( (o,ix) => o.resultado === 0 ).length <= 0 )  &&
                            <div>
                            <Typography>Sem solicitações de corte.</Typography>
                                <br/>
                            </div>
                        }
                    </Grid>
                    <Typography variant="h4" align="center" className={classes.sectionTitle}>
                        BANDAS PRONTAS PARA APLICAÇÃO: ({ordemServicos.filter( (o,ix) => [2,4].includes(o.resultado)).length})
                    </Typography>
                    <Grid container item className={classes.mainOSLista}  xs={12} sm={12} md={12} lg={12} xl={12}>
                        { ordemServicos
                            .filter( (o,ix) => [2,4].includes(o.resultado) )
                            .map( (e, ix) => {
                                return (<CorteOSGrid key={ix} ordemServico={e} index={ix} cbOpenCorte={props.cbOpenCorte} /> );
                            }) }
                        {
                            (ordemServicos.filter( (o,ix) => [2,4].includes(o.resultado) ).length <= 0 )  &&
                            <div>
                                <Typography>Sem ordens na prateleira.</Typography>
                                <br/>
                            </div>
                        }
                    </Grid>

                </Grid>

        </React.Fragment>
    )

}

export default CorteOperacaoView;
